import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { CountdownTimer } from '../models/countdown-timer';

@Component({
  selector: 'lib-countdown-timer-editor',
  templateUrl: './countdown-timer-editor.component.html',
  styleUrls: ['./countdown-timer-editor.component.scss']
})
export class CountdownTimerEditorComponent implements OnInit, OnChanges {
  @Input() data: CountdownTimer;
  @Input() isLoading = false;
  @Input() imageUrl: string;
  @Input() reset$ = new Subject();
  @Output() handleSubmit = new EventEmitter();

  public bindingData: CountdownTimer;
  private _outputData = {
    dateTime: {},
    styles: {}
  };

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && changes.data.currentValue) {
      this.bindingData = {...changes.data.currentValue};
      this._outputData = {...changes.data.currentValue};
    }
  }

  ngOnInit() {
  }

  onDatetimeSubmit($event) {
    if ($event) {
      this._outputData.dateTime = { ...$event };
      this.handleSubmit.emit({ data: { ...this._outputData }, forceUpdate: false });
    }
  }

  onDatetimeValid($event) {
    if (!$event) {
      this._outputData.dateTime = null;
      this.handleSubmit.emit({ data: { ...this._outputData }, forceUpdate: false });
    }
  }

  onStylesSubmit($event) {
    if ($event) {
      this._outputData.styles = { ...$event };
      this.handleSubmit.emit({ data: { ...this._outputData }, forceUpdate: false });
    }
  }

  onStylesValid($event) {
    if (!$event) {
      this._outputData.styles = null;
      this.handleSubmit.emit({ data: { ...this._outputData }, forceUpdate: false });
    }
  }
}
